import styled from 'styled-components';

import Modal from 'components/modal';
import { primitive } from 'styles/constants/primitives';

import { IDisabledElement } from './types';

export const StyledDialog = styled(Modal)`
  max-width: none;
  height: 100%;
  width: 100%;
  h2 {
    padding: 0 1rem;
    border: none;
    font-weight: 900;
    font-size: ${primitive.$spacing6};
  }

  ${Styles.desktop`
    &&& {
      width: ${Styles.layout.smallerSectionMaxWidth};
      height: calc(100% - 20rem);
    }
  `};
`;

export const ScheduleInputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const InputContainer = styled.div<IDisabledElement>`
  width: calc(50% - 10px);
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  input {
    color: ${Styles.color.black};
    cursor: pointer;
  }
`;

export const TextLabel = styled.label`
  color: ${primitive.th.$coffeeBrown};
  font-weight: 800;
`;

export const IconContainer = styled.div`
  background: ${primitive.th.$frenchVanilla};
  padding: ${primitive.$spacing4};
  width: ${primitive.$spacing10};
  border-radius: 50%;
  margin: 0 auto ${primitive.$spacing2};
`;

export const ListWrapper = styled.ul`
  padding-left: 0;
  list-style: none;
  max-height: 45vh;
  overflow: scroll;
  margin: 0;
  padding: ${primitive.$spacing3} 0;
  position: relative;

  ${Styles.desktop`
    max-height: 220px;
  `}
`;

export const ListItem = styled.li<IDisabledElement>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: ${primitive.$spacing2};

  // We cannot style radio button from components library directly, styling from the parent
  label {
    margin: 0;
    padding-bottom: ${primitive.$spacing4};
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    & > div {
      margin: 0;
    }
  }

  span[label] {
    border-color: inherit;
  }

  ${({ disabled }) =>
    disabled &&
    `
      color: ${primitive.th.$coffeeBrownLight};
      
    `}
`;

export const ListItemLabel = styled.span`
  font-size: ${primitive.$spacing4};
  font-weight: 800;
`;

export const StyledButtonGroup = styled.div`
  width: 100%;
  margin-top: ${primitive.$spacing6};
  button {
    margin-bottom: ${primitive.$spacing2};
    border-radius: ${primitive.$spacing3};
    height: ${primitive.$spacing9};
    line-height: 1;
  }
`;

export const ScheduleForm = styled.form`
  width: 100%;
`;

export const Description = styled.span`
  display: block;
  font-size: 0.875rem;
`;
